var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Icon } from "../../UI";
import { Translate } from "../../I18N";

export class PrioritySortingLabel extends Component {
  render() {
    return /*#__PURE__*/(
      _jsx("label", { className: "property-label", htmlFor: this.props.htmlFor }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Priority sorting"), /*#__PURE__*/
      _jsx("span", { className: "property-help" }, void 0, /*#__PURE__*/
      _jsx(Icon, { icon: "question-circle" }), /*#__PURE__*/
      _jsx("div", { className: "property-description" }, void 0, /*#__PURE__*/
      _jsx(Translate, { translationKey: "Priority sorting description" }, void 0, "Properties marked as priority sorting will be used as default sorting criteria. If more than one property is marked as priority sorting the system will try to pick-up the best fit. When listing mixed template types, the system will pick-up the best combined priority sorting."




      )
      )
      )
      ));

  }
}





export default connect()(PrioritySortingLabel);